<template>
  <v-card>
    <v-toolbar color="primary" class="rounded-0 text-white" height="80px">
      <v-toolbar-title class="ml-3">
        <h2><b>Tanımlar</b> - Kanal Listesi</h2>
      </v-toolbar-title>
      <v-spacer />
      <div class="d-flex align-items-center">
        <v-icon
          color="error cursor-pointer"
          class="mr-2"
          dark
          :disabled="!isSelectable"
          @click="showDeleteChannelModal"
          v-permission="{
            permissions: ['channels-delete'],
          }"
        >
          mdi-delete
        </v-icon>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="cursor-pointer"
              v-bind="attrs"
              dark
              @click="() => fetchChannels()"
              v-on="on"
            >
              mdi-reload
            </v-icon>
          </template>
          <span>Yenile</span>
        </v-tooltip>
        <v-text-field
          v-model="search"
          label="Ara"
          dark
          class="mx-4 mt-0 pt-0"
          hide-details="auto"
          single-line
          append-icon="search"
        ></v-text-field>
        <router-link
          :to="{ name: 'def-channels-edit', query: { editable: true } }"
        >
          <v-btn
            v-permission="{
              permissions: ['channels-create'],
            }"
            elevation="0"
            color="success"
          >
            <v-icon>mdi-plus</v-icon>
            Yeni Kanal
          </v-btn>
        </router-link>
      </div>
      <KTTopMenu></KTTopMenu>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        v-model="selectedChannel"
        :headers="headers"
        :items="channels"
        :search="search"
        :single-select="true"
        sort-by="id"
        sort-desc="true"
        :items-per-page="100"
        :loading="loading"
        show-select
        item-key="id"
      >
        <template #item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <router-link
                v-permission="{
                  permissions: ['channels-update'],
                }"
                :to="{
                  name: 'def-channels-edit',
                  params: { id: item.id },
                  query: { editable: true },
                }"
              >
                <v-icon color="warning" small v-bind="attrs" v-on="on">
                  mdi-pencil
                </v-icon>
              </router-link>
            </template>
            <span>Görüntüle</span>
          </v-tooltip>
        </template>
        <template #item.name="{ item }">
          <router-link
            :to="{
              name: 'def-channels-edit',
              params: { id: item.id },
              query: { editable: false },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import KTTopMenu from "@/view/layout/header/TopMenu.vue";
import {
  FETCH_CHANNELS,
  DELETE_CHANNEL,
} from "@/core/services/store/definitions/channels.module";

export default {
  name: "ChannelList",
  components: {
    KTTopMenu,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "İsim", value: "name", align: "left" },
        {
          text: "",
          value: "actions",
          align: "left",
          width: "100px",
          sortable: false,
        },
        { text: "", value: "data-table-select", align: "right" },
      ],
      selectedChannel: [],
      loading: true,
    };
  },
  mounted() {
    this.fetchChannels().then(() => (this.loading = false));
  },
  methods: {
    ...mapActions([FETCH_CHANNELS, DELETE_CHANNEL]),
    async acceptDelete() {
      try {
        await this.deleteChannel(this.selectedChannel[0]);
        this.$toast.success("Kanal silindi", {
          position: "bottom-right",
          duration: 2000,
        });
        this.selectedChannel = [];
      } catch (error) {
        const message =
          error[0].code === "QueryException"
            ? "Bu kanal bir lead ve ya kampanya ile ilişkili olduğu için silinemez."
            : error[0].detail;
        this.$toast.error(message, {
          position: "bottom-right",
          duration: 2000,
        });
      }
    },
    showDeleteChannelModal() {
      const params = {
        title: "Seçtiğiniz kanal silinecek",
        text: "Seçili kanalı silmek istediğinize emin misiniz?",
        onConfirm: () => {
          return this.acceptDelete();
        },
      };
      this.$approvalModal.show(params);
    },
  },
  computed: {
    ...mapGetters(["channels"]),
    isSelectable() {
      return this.selectedChannel.length > 0;
    },
  },
};
</script>

<style scoped></style>
